// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"PyQPyDuS","customContent":"b5yJeEJn","mediaResearchIcon":"_1p3MPzpf"};